import { useIonAlert } from '@ionic/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useExportChartMutation } from '../graphql/generated';

type DownloadChart = (chartId: string) => void;

export const useDownloadChartLazy = (): DownloadChart => {
  const { i18n } = useTranslation();
  const [present] = useIonAlert();

  const [downloadChart] = useExportChartMutation();

  const downloadChartAlert = useCallback(
    (chartId: string) => {
      present(i18n.t('common:chart_sending'), [
        {
          text: i18n.t('common:send'),
          handler: () => {
            downloadChart({
              variables: {
                input: {
                  id: chartId,
                  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                },
              },
            });
          },
        },
        {
          text: i18n.t('common:cancel'),
          role: 'cancel',
        },
      ]);

      return;
    },
    [downloadChart, present, i18n]
  );

  return downloadChartAlert;
};
